<ifc-app-scroll-container class="ifc-app-scroll-container-center">
    <div id="main" fxLayout="column" fxLayoutAlign="center center">

        <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="48px" fxFlexFill.lt-lg
             ngClass.lt-lg="fit-content">

            <div class="layout padding-horizontal align-center">
                <span class="title">How much would you like to pay today?</span>
            </div>

            <div fxLayout.gt-md="row" fxLayoutAlign.gt-md="start start" fxLayoutGap.gt-md="48px" fxLayout="column"
                 fxLayoutAlign="start center">

                <form [formGroup]="form">

                    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutAlign.lt-md="start center"
                         fxLayoutGap="24px">
                        <div [ngClass.xl]="'form-field-lg'" [ngClass.gt-xs]="'form-field-md'"
                             [ngClass.xs]="'form-field-xs'">
                            <div class="mat-caption sub-title">{{ paymentFrequency }} amount (debited from your bank
                                account {{ paymentFrequency | lowercase }})
                            </div>
                            <button mat-stroked-button disabled class="disabled">
                                <span class="color-primary">{{ data?.weeklyPaymentAmount | currency:'$' }}</span>
                            </button>
                        </div>
                        <div [ngClass.xl]="'form-field-lg'"
                             [ngClass.gt-xs]="'form-field-md'"
                             [ngClass.xs]="'form-field-xs'"
                             *ngIf="data?.productCode === ProductCode.LOC || data?.productCode === ProductCode.Law">
                            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                <mat-label>Other amount</mat-label>
                                <input matInput autocomplete="off" placeholder="Other amount" currencyMask
                                       formControlName="paymentAmount">
                            </mat-form-field>
                            <div class="mat-caption sub-title">
                                Enter an amount between {{ minimumAmount | currency:'$' }} and
                                {{ maximumAmount | currency:'$' }}
                            </div>
                        </div>
                        <div [ngClass.xl]="'form-field-lg'" [ngClass.gt-xs]="'form-field-md'"
                             [ngClass.xs]="'form-field-xs'">
                            <button mat-stroked-button type="button"
                                    [ngClass]="{'selected': form.controls.paymentAmount.value === maximumAmount}"
                                    (click)="setAmount(maximumAmount)">
                                <span class="color-primary">{{ maximumAmount | currency:'$' }}</span>
                            </button>
                            <div class="mat-caption sub-title">Payoff amount</div>
                        </div>
                    </div>

                    <ifc-promo-code [data]="data.accountTransferData"
                                    (promotionApplied)="applyPromotionChanged($event)"></ifc-promo-code>

                </form>

                <ifc-transaction-details [data]="data.accountTransferData"></ifc-transaction-details>

            </div>
        </div>
    </div>
</ifc-app-scroll-container>
